import BenchlingConfig from 'BenchlingConfig';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

// Keep in sync with `benchling/machine_learning/create_shapash_dashboard.ts:SHAPASH_DASHBOARD_NAME
export const SHAPASH_DASHBOARD_NAME = 'SHAPASH';

export default function isShapashDashboard(dashboardAttrs: Pick<AnalyticsDashboard, 'name'>): boolean {
  return (
    BenchlingConfig.INSIGHTS_ENABLE_SHAPASH_CONTROLLER_TABLES &&
    dashboardAttrs.name.toUpperCase() === SHAPASH_DASHBOARD_NAME
  );
}
